export default __webpack_public_path__ + "static/media/HYD-5.6191196e.webp";